// 导入封装好的网络请求类工具
import service from "./axios";

// 获取省市区数据
export const getAreaData = () => {
  return service({
    url: "/apply/district/getDistrictList",
    method: "post",
    code: "v4"
  });
};

// 字典
export const getTypeDefData = data => {
  return service({
    url: "/apply/typeDef/typeDefListAll",
    method: "post",
    data,
    code: "v4"
  });
};

//
export const getProcessList = () => {
  return service({
    url: "/apply/orderInfo/getorderInfoList",
    method: "get",
    code: "v4"
  });
};

// 文件查看
export const checkFile = data => {
  return service({
    url: "/file/fileInfo/getFile?id=" + data,
    method: "get",
    code: "v4"
  });
};



// WEBPACK FOOTER //
// ./src/api/common.js